export default {
  lang: {
    confirm: {
      title: 'Haluatko varmasti poistaa sen? Et voi palauttaa sitä poistamisen jälkeen',
      okText: 'Poistaa',
      cancelText: 'Peruus',
    },
  },
};
